/** Max upload size for a screen live-preview JPEG (256 KiB). */
export const PLAYER_LIVE_PREVIEW_MAX_BYTES = 256 * 1024

/** Target max width when the player scales captures before upload. */
export const PLAYER_LIVE_PREVIEW_MAX_WIDTH_PX = 320

/** Minimum interval between successful player uploads (5 minutes). */
export const PLAYER_LIVE_PREVIEW_MIN_UPLOAD_INTERVAL_MS = 5 * 60 * 1000

export const PLAYER_LIVE_PREVIEW_ALLOWED_CONTENT_TYPES = ['image/jpeg', 'image/webp'] as const

export type TPlayerLivePreviewContentType = typeof PLAYER_LIVE_PREVIEW_ALLOWED_CONTENT_TYPES[number]

export function playerLivePreviewR2Prefix(tenantId: string): string {
  return `live-preview/${tenantId}/`
}

export function playerLivePreviewR2Key(tenantId: string, playerId: string): string {
  return `${playerLivePreviewR2Prefix(tenantId)}${playerId}.jpg`
}

export function isPlayerLivePreviewContentType(value: string): value is TPlayerLivePreviewContentType {
  return (PLAYER_LIVE_PREVIEW_ALLOWED_CONTENT_TYPES as readonly string[]).includes(value)
}

export function playerLivePreviewCapturedAtMs(value: unknown): number | null {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.getTime()
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Date.parse(value)
    return Number.isNaN(parsed) ? null : parsed
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value
  }
  return null
}

export function playerHasLivePreview(capturedAt: Date | null | undefined): boolean {
  return capturedAt instanceof Date && !Number.isNaN(capturedAt.getTime())
}
